// extracted by mini-css-extract-plugin
export default {"root":"style_root__pB0B5","header":"style_header__+pzzj","content":"style_content__bL0sP"};